var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as ClientActions from '../actions/client';
import * as SignoutActions from '../actions/auth/SignOut';
import * as RestoreActions from '../actions/auth/restore';
import { CONFIG } from '../config';
import { deleteAccessToken } from '../shared/tokenUtils';
var initialState = {
    country: CONFIG.countryCode,
    ip: '127.0.0.1',
    fetched: false
};
export default function balance(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case ClientActions.SUCCESS_FETCH_CLIENT_INFO:
            if (!action.data.error) {
                return __assign(__assign({}, state), { ip: action.data.ip, fetched: true });
            }
            return __assign(__assign({}, state), { fetched: true });
        case ClientActions.FAILURE_FETCH_CLIENT_INFO:
            return __assign(__assign({}, state), { fetched: true });
        case SignoutActions.SIGNOUT:
            return __assign(__assign({}, state), { fetched: true });
        case RestoreActions.SUCCESS_RESTORE:
            var data = action.data;
            var malformed = data.malformed;
            var expired = data.expired;
            if (expired || malformed) {
                deleteAccessToken();
                return initialState;
            }
            return __assign(__assign({}, state), { fetched: true });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/clientReducer.js